var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"note-wrap"}},[(!_vm.note)?_c('div',[_vm._v("\n    리뷰가 없습니다~\n  ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"note-content"},domProps:{"innerHTML":_vm._s(_vm.note)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04ba156b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/spa/project-watching/Note.vue
// module id = null
// module chunks = 